import Link from '@mui/material/Link'
import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { HomepageLogo } from '..'
import type { WhoAmIPermissions } from '../../../../../types'
import sharedStyles from '../../HeaderNavigation.module.scss'
import { isNavDropdown, useNavConfig } from '../../config/useNavConfig'
import styles from './DesktopNavigation.module.scss'
import NavDropdown from './NavDropdown'
import NavLink from './NavLink'

interface DesktopNavigationProps {
  userPermissions: WhoAmIPermissions | null
}

const DesktopNavigation = ({ userPermissions }: DesktopNavigationProps) => {
  const navConfig = useNavConfig(userPermissions)

  return (
    <>
      <HomepageLogo href="/" />
      <>
        <div className={styles.DesktopNavigation}>
          {navConfig.map((item) => {
            if (!item.isVisibleForUserRole) {
              return null
            }

            if (isNavDropdown(item)) {
              return (
                <NavDropdown
                  subItems={item.subItems}
                  title={item.title}
                  key={item.title}
                />
              )
            }

            return <NavLink {...item} key={item.title} />
          })}
        </div>
        <StandaloneLink href="/logout" text="Logout" />
      </>
    </>
  )
}

const StandaloneLink = ({ href, text }: { href: string; text: string }) => (
  <Link
    component={ReactRouterLink}
    to={href}
    className={sharedStyles.login}
    sx={{
      color: 'black',
      alignItems: 'center',
      cursor: 'pointer',
      textDecoration: 'none',
    }}
  >
    {text}
  </Link>
)

export default DesktopNavigation
